import React from 'react';
import InputText from '../../../../../components/modalComponents/InputText';
import ToggleSwitch from '../../UI/ToggleSwitch';
import './Step2Configuracion.css';

/**
 * Componente para el Paso 2: Configuración de Evaluación
 * Diseño consistente con Step 1
 * Incluye: instrucciones, tiempo límite, puntaje, peso de calificación, estado y checkbox obligatoria
 */

const Step2Configuracion = ({
  formData,
  errors,
  handleInputChange,
  setFormData,
  onToggleEstado,
}) => {
  return (
    <div className="step2-container">
      <div className="step2-card">
        {/* Instrucciones */}
        <div className="step2-form-row">
          <div className="step2-form-col step2-form-col-full">
            <label className="step2-label">
              Instrucciones
            </label>
            <textarea
              name="instrucciones"
              value={formData.instrucciones}
              onChange={handleInputChange}
              className="step2-textarea"
              placeholder="Escriba las instrucciones para completar esta evaluación..."
              aria-label="Instrucciones de la evaluación"
            />
          </div>
        </div>

        <div className="step2-divider"></div>

        {/* Tiempo Límite y Peso de Calificación */}
        <div className="step2-form-row">
          <div className="step2-form-col step2-form-col-half">
            <InputText
              label="Tiempo Límite (Minutos)"
              name="tiempoLimite"
              value={formData.tiempoLimite}
              onChange={handleInputChange}
              isRequired={true}
              hasValidationMessage={true}
              validationMessage={errors.tiempoLimite}
              direction="column"
              placeholder="30"
              type="text"
              inputMode="numeric"
            />
          </div>
          <div className="step2-form-col step2-form-col-half">
            <InputText
              label="Peso de Calificación (%)"
              name="pesoCalificacion"
              value={formData.pesoCalificacion}
              onChange={handleInputChange}
              isRequired={false}
              direction="column"
              placeholder="0-100"
              type="number"
              min="0"
              max="100"
              step="0.01"
            />
            <small className="step2-hint-text">
              Rango permitido: 0 a 100 (%).
            </small>
          </div>
        </div>

        <div className="step2-divider"></div>

        {/* Estado */}
        <div className="step2-form-row">
          <div className="step2-form-col step2-form-col-full">
            <ToggleSwitch
              label="Estado"
              checked={formData.estadoActivo}
              onChange={() => {
                if (typeof onToggleEstado === 'function') {
                  onToggleEstado();
                } else {
                  setFormData(prev => ({ ...prev, estadoActivo: !prev.estadoActivo }));
                }
              }}
              activeText="Activo"
              inactiveText="Inactivo"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Step2Configuracion;
